import { useState, useEffect } from "react";
import axios from "axios";

const useSections = () => {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSections = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/sections`);
        if (response.data.status === "OK") {
          // Add unique IDs to each section
          const sectionsWithIds = response.data.sections.map(section => ({
            ...section,
            id: `${section.slug}-${Date.now()}`
          }));
          setSections(sectionsWithIds);
        }
      } catch (err) {
        setError(err.message);
        console.error("Error fetching sections:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSections();
  }, []);

  return { sections, loading, error };
};

export default useSections;
